import styled from "styled-components";
import { SecondaryButton } from "styles/elements";
import { FlexRow } from "styles/layout";
import { Theme } from "theme";

export const ToggleContainer = styled(FlexRow)`
  column-gap: 15px;
  row-gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 700px) {
    column-gap: 10px;
  }
`;

// todo - extract this styling since could be reusable in non filter situations??
export const ToggleOption = styled.div<{ selected: boolean }>`
  border: ${Theme.multiSelectFilterBorder};
  border-radius: ${Theme.multiSelectFilterBorderRadius};
  box-shadow: ${Theme.panelContentBoxShadowFainter};
  padding: 6px 20px;
  cursor: pointer;

  @media (max-width: 700px) {
    padding: 6px 10px;

    font-size: 10.5pt;
  }

  ${({ selected }) =>
    !selected &&
    `background: ${Theme.multiSelectFilterUnselectedBackground}; color: ${Theme.multiSelectFilterUnselectedForeground}`}
  ${({ selected }) =>
    selected &&
    `background: ${Theme.multiSelectFilterSelectedBackground};  color: ${Theme.multiSelectFilterSelectedForeground}`}
`;

export const FunctionsContainer = styled(FlexRow)`
  margin-top: 10px;
  justify-content: flex-end;
`;
